import { apiService } from '../api';
import {
  InventoryItem,
  CreateInventoryItemRequest,
  InventoryItemFilters,
  StockMovement,
  StockAdjustmentRequest,
} from '../../types/inventory';

const BASE = '/inventory/items';

export const inventoryItemService = {
  async getItems(filters: InventoryItemFilters): Promise<InventoryItem[]> {
    const response = await apiService.get<InventoryItem[]>(BASE, filters);
    return response.data;
  },

  async getItem(id: string): Promise<InventoryItem> {
    const response = await apiService.get<InventoryItem>(`${BASE}/${id}`);
    return response.data;
  },

  async createItem(data: CreateInventoryItemRequest): Promise<InventoryItem> {
    const response = await apiService.post<InventoryItem>(BASE, data);
    return response.data;
  },

  async updateItem(id: string, data: Partial<CreateInventoryItemRequest>): Promise<InventoryItem> {
    const response = await apiService.put<InventoryItem>(`${BASE}/${id}`, data);
    return response.data;
  },

  async toggleActive(id: string): Promise<InventoryItem> {
    const response = await apiService.patch<InventoryItem>(`${BASE}/${id}/active`);
    return response.data;
  },

  async deleteItem(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}`);
  },

  async hardDeleteItem(id: string): Promise<void> {
    await apiService.delete(`${BASE}/${id}/hard`);
  },

  // Manual stock adjustment (in / out / wastage) — returns the recorded movement
  async adjustStock(id: string, data: StockAdjustmentRequest): Promise<StockMovement> {
    const response = await apiService.post<StockMovement>(`${BASE}/${id}/adjust`, data);
    return response.data;
  },

  // Stock ledger history for a single item
  async getMovements(id: string): Promise<StockMovement[]> {
    const response = await apiService.get<StockMovement[]>(`${BASE}/${id}/movements`);
    return response.data;
  },
};
